// extracted by mini-css-extract-plugin
export default {"Expandable":"styles_Expandable__eL8m6","content":"styles_content__O8SAE"};